import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';
import {DotAssetService} from '@ng-dot/core';

declare var VANTA: any;

@Component({
	standalone: false,
	selector: 'app-main-head',
	template: `
		<header id="dot-main-head">
			<div id="dot-main-head-area" class="dot-area">
				<h1 id="dot-title">{{name}}</h1>
				<ng-content></ng-content>
				<div id="sub-wall"></div>
			</div>
		</header>
	`,
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainHeadComponent /*implements AfterViewInit, OnDestroy*/ {
	@Input() name = 'Untitled';

	constructor(protected _asset: DotAssetService) {
	}

	/*
		effect: any;

		ngAfterViewInit() {
			this._asset.script(
				'assets/scripts/three.r92.min.js',
				'assets/scripts/vanta.waves.min.js'
			).subscribe(() => {
				this.effect = VANTA.WAVES({
					el        : '#sub-wall'
				});
			});
		}

		ngOnDestroy() {
			const {effect} = this;
			if (effect) {
				effect.destroy();
			}
		}*/
}
